import CreateInvestmentError from './CreateInvestmentError';
class InvestorCannotOperate extends CreateInvestmentError {
    constructor(options) {
        super('Trader cannot operate due to their account level', options);
    }
}
export default InvestorCannotOperate;
